module.exports = __webpack_public_path__ + "img/app-store-icon.c505315d.webp";